var map = {
	"./banner/banner-1.jpg": 4233,
	"./banner/banner-2.jpg": 8094,
	"./en/logo-13.png": 208,
	"./en/main-view-logo.png": 4569,
	"./order-status/clinic/-1-defule.png": 5111,
	"./order-status/clinic/0-訂單建立中.png": 7034,
	"./order-status/clinic/1-3-訂單開放媒合.png": 7827,
	"./order-status/clinic/13-2-d-1-訂單執行中途確認.png": 4395,
	"./order-status/clinic/13-2-p-1-訂單執行中途確認.png": 5615,
	"./order-status/clinic/13-3-1-訂單執行中途確認.png": 837,
	"./order-status/clinic/15-2-d-0-訂單製作完成寄送中.png": 5400,
	"./order-status/clinic/15-2-d-1-訂單製作完成寄送中.png": 3749,
	"./order-status/clinic/15-2-p-0-訂單製作完成寄送中.png": 8252,
	"./order-status/clinic/15-2-p-1-訂單製作完成寄送中.png": 2153,
	"./order-status/clinic/15-3-0-訂單完成寄送中.png": 5107,
	"./order-status/clinic/15-3-1-訂單完成寄送中.png": 7190,
	"./order-status/clinic/16-2-d-0-訂單製作完成待診所確認.png": 3329,
	"./order-status/clinic/16-2-d-1-訂單製作完成待診所確認.png": 1168,
	"./order-status/clinic/16-2-p-0-訂單製作完成待診所確認.png": 4997,
	"./order-status/clinic/16-2-p-1-訂單製作完成待診所確認.png": 7508,
	"./order-status/clinic/16-3-0-訂單製作完成待診所確認.png": 2171,
	"./order-status/clinic/16-3-1-訂單製作完成待診所確認.png": 4218,
	"./order-status/clinic/2-3-訂單已媒合未確認.png": 6901,
	"./order-status/clinic/21-2-d-訂單執行中.png": 4919,
	"./order-status/clinic/21-2-p-訂單執行中.png": 4675,
	"./order-status/clinic/21-3-訂單執行中.png": 3930,
	"./order-status/clinic/22-2-d-1-訂單執行中.png": 2734,
	"./order-status/clinic/22-2-p-1-訂單執行中.png": 2082,
	"./order-status/clinic/22-3-1-訂單執行中.png": 5176,
	"./order-status/clinic/3-2-p-訂單齒模寄送.png": 1719,
	"./order-status/clinic/4-2-d-訂單等待技工所確認.png": 308,
	"./order-status/clinic/5-2-d-訂單已確認.png": 478,
	"./order-status/clinic/5-2-p-訂單已確認.png": 2842,
	"./order-status/clinic/5-3-訂單已確認.png": 9960,
	"./order-status/clinic/98-訂單取消.png": 9545,
	"./order-status/clinic/99-2-d-0-訂單完成.png": 6451,
	"./order-status/clinic/99-2-d-1-訂單完成.png": 4080,
	"./order-status/clinic/99-2-p-0-訂單完成.png": 5783,
	"./order-status/clinic/99-2-p-1-訂單完成.png": 6324,
	"./order-status/clinic/99-3-0-訂單完成.png": 8677,
	"./order-status/clinic/99-3-1-訂單完成.png": 8266,
	"./order-status/status-999.jpg": 1668,
	"./zh-CN/logo-13.png": 6891,
	"./zh-CN/main-view-logo.png": 7004,
	"./zh-HK/logo-13.png": 9599,
	"./zh-HK/main-view-logo.png": 9656,
	"./zh-TW/logo-13.png": 7143,
	"./zh-TW/main-view-logo.png": 4000,
	"./zh/logo-13.png": 2803,
	"./zh/main-view-logo.png": 8084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3747;